import styled from "styled-components";

export const Header = styled.div`
  margin: 0 auto 5px;
  width: 100%;
  max-width: 860px;
  display: flex;
  @media (max-width: 910px) {
    display: none;
  }
`;
export const TitleBox = styled.div`
  width: ${({ width }) => width && width};
`;
export const HeaderTitle = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: #808080;
`;
